import type { LoginResponse, User } from "../../domain/types";

/**
 * Mapper para la feature de Auth.
 */
export const authMapper = {
	toDomainUser(dto: User): User {
		return {
			id: dto.id,
			email: dto.email,
			name: dto.name,
			role: dto.role,
			is_system: dto.is_system,
			is_active: dto.is_active,
			created_at: dto.created_at,
			team_role: dto.team_role,
		};
	},

	toDomainLogin(dto: LoginResponse): LoginResponse {
		return {
			user: this.toDomainUser(dto.user),
			expires_in: dto.expires_in,
			csrf_token: dto.csrf_token,
		};
	},
};
